<template>
  <div class="container reportDetail">

    <div class="handle-box">
      <el-tabs v-model="currentTab" @tab-click="handleClick">
        <el-tab-pane v-for="report in feedbackInfo.feedbackReports" :label="report.reportNo" :name="index">
          <ReportDetail_ReportItem ref='feedbackDetail' :value="report" :oldFeedbackDebits="oldFeedbackDebits" :feedback="feedbackInfo.feedback"></ReportDetail_ReportItem>
        </el-tab-pane>
        <el-tab-pane :label="$t('storeFeedback.report.feedbackDetail')" name="feedbackDetail">
          <ReportDetail_feedbackDetail v-model="feedbackInfo.feedback" @setLevel="setLevel" @resetReportItem="getData(true)" />
        </el-tab-pane>
        <el-tab-pane :label="$t('storeFeedback.report.finalDebitInfo')" name="finalDebitInfo">
          <div class="toolsBox" v-if="operationDeductAccounts">
            <el-button type="primary" v-acl="FeedbacksDebitsSave" @click="saveInfo('SAVE')">{{ $t('common.save')}}</el-button>
            <el-button type="primary" v-acl="FeedbacksDebitsSubmit" @click="saveInfo('SUBMIT')">{{ $t('common.submit')}}</el-button>
            <el-button type="primary" size="small" v-acl="FeedbacksDebitsSave" @click="sendData('SAVE')">下发餐厅扣账信息</el-button>
            <el-divider></el-divider>

            <el-row style="margin-top:10px;">
              <el-form :inline="true" :model="feedbackInfo.feedback" :rules="rules" ref="restaurantNumForm" class="demo-form-inline">
                <el-form-item label="餐厅扣账数量" prop="storeDebitQty">
                  <el-input v-model="feedbackInfo.feedback.storeDebitQty" :disabled="!(operationDeductAccounts && haveFeedbacksDebitsNew) || feedbackInfo.feedback.isIssued == '是' ? true : false"></el-input>
                </el-form-item>
                <el-form-item label="是否下发成功" prop="isIssued">
                  <div>
                    <!-- {{ feedbackInfo.feedback.isIssued?'是':'否' }} -->
                  </div>
                  <el-input v-model="feedbackInfo.feedback.isIssued" disabled></el-input>
                </el-form-item>
                <el-form-item label="下发时间" prop="issueDate">
                  <div>
                    <!-- {{ feedbackInfo.feedback.issueDate }} -->
                  </div>
                  <el-input v-model="feedbackInfo.feedback.issueDate" disabled></el-input>
                </el-form-item>
              </el-form>
            </el-row>
            <el-divider></el-divider>
          </div>

          <div class="toolsBox" v-if="operationDeductAccounts" style='margin-bottom:20px'>
            <el-button type="primary" size="small" v-acl="FeedbacksDebitsSave" @click="addRow">{{ $t('common.addNewRow')
            }}</el-button>
            <el-button type="danger" size="small" v-acl="FeedbacksDebitsSave" @click="delRow">{{ $t('common.delRow')
            }}</el-button>
          </div>
          <el-table :data="feedbackInfo.feedbackDebits" ref="feedbackDebits" align="center" border highlight-current-row class="table">
            <el-table-column label="选择" width="50">
              <template slot-scope="scope">
                <el-radio v-model="radioVal" @change.native="getSelectRow(scope.row)" :label="scope.row.delIds">&nbsp;</el-radio>
              </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip prop="debitMonth" :label="$t('storeFeedback.debitMonth')">
              <template slot-scope="scope">
                <!-- <el-date-picker popper-class="mouthClass" v-model="scope.row.debitMonth" value-format="yyyy-MM" format="yyyy-MM" type="month" :disabled='!(operationDeductAccounts &&haveFeedbacksDebitsNew)' placeholder="选择月">
                </el-date-picker> -->
                <el-date-picker v-model="scope.row.debitMonth" value-format="yyyy-MM" format="yyyy-MM" type="month" :disabled='!(operationDeductAccounts && haveFeedbacksDebitsNew)' placeholder="选择月">
                </el-date-picker>
              </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip prop="supDebitNum" :label="$t('storeFeedback.supDebitNum')">
              <template slot-scope="scope">
                <el-input type="number" oninput="if(value.length > 10) value=value.slice(0, 10)" v-model="scope.row.supDebitNum" :disabled='!(operationDeductAccounts && haveFeedbacksDebitsNew)'></el-input>
              </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip prop="dcDebitNum" :label="$t('storeFeedback.dcDebitNum')">
              <template slot-scope="scope">
                <el-input type="number" oninput="if(value.length > 10) value=value.slice(0, 10)" v-model="scope.row.dcDebitNum" :disabled='!(operationDeductAccounts && haveFeedbacksDebitsNew)'></el-input>
              </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip prop="debitRemark" :label="$t('common.remarks')" align="left">
              <template slot-scope="scope">
                <el-input v-model="scope.row.debitRemark" :disabled='!(operationDeductAccounts && haveFeedbacksDebitsNew)' maxlength="200"></el-input>
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>
<script>
import reportApi from "@/api/storeFeedback/report";
import ReportDetail_ReportItem from "@/components/page/storeFeedback/approveReport/approveDetail_reportItem";
import commonFun from "@/utils/commonFun";
import ReportDetail_feedbackDetail from "@/components/page/storeFeedback/approveReport/approveDetail_feedbackDetail";

export default {
  components: { ReportDetail_feedbackDetail, ReportDetail_ReportItem },
  data() {
    return {
      isNew: false,
      nodeList: [],
      stepsActive: -1,
      operationDeductAccounts: true,
      haveFeedbacksDebitsNew: true,
      feedbackId: null,
      feedbackReportId: null,
      feedbackInfo: {
        feedbackReports: {},
        feedback: {
          feedbackFirstCheck: {},
          feedbackComplaint: {},
          feedback: {}
        },
      },
      isCopyCreate: false,
      currentTab: 0,
      roles: [],
      radioVal: null,
      selectRow: null,
      oldFeedbackDebits: [],
      rules: {
        storeDebitQty: [
          { required: true, message: '请输入餐厅扣账数量后再下发!', trigger: 'blur' }
        ],
      },
    }
  },
  created() {
    let that = this;
    that.roles = JSON.parse(localStorage.getItem("ms_roles"));
    let roles = JSON.parse(localStorage.getItem("ms_roles"));
    let emplFlag = localStorage.getItem('ms_emplFlag');
    //门店      SF_STORE_BASIC
    //反馈中心  SF_FBC_BASIC
    //麦当劳   SF_MCD_BASIC
    //供应商  SF_SUP_BASIC
    for (let i = 0, len = roles.length; i < len; i++) {
      if (roles[i] == 'SF_STORE_BASIC') {//门店
        this.isStore = true;
      }
      if (roles[i] == 'SF_FBC_BASIC') {//反馈中心
        this.isFBC = true;
        // this.operationDeductAccounts = true //只有反馈中心可以操作扣账信息
      }
      if (roles[i] == 'SF_MCD_BASIC') {//麦当劳
        this.isMCD = true;
      }

    }
    if (emplFlag == "SUP") {//供应商
      this.isSUP = true;
    }
    this.getData()
    if (this.$route.query.action) {
      let action = this.$route.query.action;
      if (action == 'create') {
        this.isNew = true
      }
    }
    // 如果没有新增扣账信息权限
    if (this.actionCheck.actionCheck('FeedbacksDebitsNew') === false) {
      this.haveFeedbacksDebitsNew = false
    }

  },
  methods: {
    setLevel(val) {
      console.log("🚀 ~ file: approveDetail.vue:131 ~ setLevel ~ val:", val)
    },
    handleClick() {
      // this.getData()
    },
    getData(onlyFeedback) {
      this.feedbackId = this.$route.query.feedbackId;
      this.feedbackReportId = this.$route.query.feedbackReportId;

      let action = this.$route.query.action;
      let that = this;
      return reportApi.getDetail(that.feedbackId, that.feedbackReportId).then(resp => {
        if (onlyFeedback) {
          that.feedbackInfo.feedback = resp.data.feedback;
          return;
        }
        that.feedbackInfo = resp.data;
        this.$set(that.feedbackInfo.feedback, 'storeDebitQty', resp.data.feedback.feedback.storeDebitQty)
        this.$set(that.feedbackInfo.feedback, 'isIssued', resp.data.feedback.feedback.isIssued ? '是' : '否')
        this.$set(that.feedbackInfo.feedback, 'issueDate', resp.data.feedback.feedback.issueDate)
        that.feedbackId = resp.data.feedback.feedback.ttFeedbackId;
        that.feedbackInfo.feedbackReports = resp.data.feedbackReports;
        if (that.feedbackInfo.feedbackDebits.length > 0) {
          //循环数组添加删除用的标示
          for (let i = 0, len = that.feedbackInfo.feedbackDebits.length; i < len; i++) {
            that.feedbackInfo.feedbackDebits[i].delIds = i
            that.feedbackInfo.feedbackDebits[i].debitMonth = that.feedbackInfo.feedbackDebits[i].debitMonth.toString()
          }
        }
        if (resp.data.feedback.feedback.debitStatus == 'SUBMIT') {
          this.operationDeductAccounts = false//提交后不能操作 扣账
        }
        let nodeList = resp.data.feedback.nodeList
        for (let i = 0, len = nodeList.length; i < len; i++) {
          if (nodeList[i].status == 'current') {
            this.stepsActive = i;
          }
        }
        this.nodeList = nodeList;
        this.oldFeedbackDebits = JSON.parse(JSON.stringify(this.feedbackInfo.feedbackDebits));
      });
    },
    saveInfo(status) {
      let that = this
      let list = this.feedbackInfo.feedbackDebits;
      let data = {
        debitList: list,
        status: status
      }
      if (status == 'SUBMIT') {
        if (list.length == 0) {
          that.$message({ message: this.$t('storeFeedback.report.NoDetailLines'), type: "warning" });
          return;
        }
        for (let i = 0, len = list.length; i < len; i++) {
          if (
            list[i].debitMonth == null ||
            list[i].debitMonth == "") {
            that.$message({ message: this.$t('storeFeedback.report.PleaseMonth'), type: "warning" });
            return;
          }
          if (
            (list[i].supDebitNum == null ||
              list[i].supDebitNum == "") &&
            (list[i].dcDebitNum == null ||
              list[i].dcDebitNum == "")

          ) {
            that.$message({ message: this.$t('storeFeedback.report.debitNumNoempty'), type: "warning" });
            return;
          }
        }
        this.$confirm(this.$t('quoteByLine.sourcing.confirmSubmit'), this.$t('common.tips'), {
          confirmButtonText: this.$t('common.confirm'),
          cancelButtonText: this.$t('common.cancel'),
          customClass: 'colorBtn',
          type: 'warning'
        }).then(() => {
          reportApi.saveDebitInfo(this.feedbackId, data).then(resp => {
            if (resp.code == 200) {
              that.$message({
                message: this.$t("common.submitSuccess"),
                type: "success"
              });
              that.operationDeductAccounts = false

            }
          });
        }).catch(() => {

        });
      } else {
        reportApi.saveDebitInfo(that.feedbackId, data).then(resp => {
          if (resp.code == 200) {
            that.$message({
              message: this.$t("common.saveSuccess"),
              type: "success"
            });

          }
        });
      }

    },
    //单选操作
    getSelectRow: function (row) {
      this.selectRow = row;
    },
    addRow() {
      let len = this.feedbackInfo.feedbackDebits.length
      var list = {
        delIds: len,
      };
      this.feedbackInfo.feedbackDebits.push(list);
    },
    delRow() {
      let that = this;
      if (that.radioVal == null || that.selectRow == null) {
        that.$message({ message: this.$t('common.pleaseSelectOneData'), type: "warning" });
        return;
      }
      let list = this.feedbackInfo.feedbackDebits;
      // 遍历源数据
      list.forEach(function (itemI, indexI) {
        if (that.selectRow.delIds === itemI.delIds) {
          list.splice(indexI, 1);
        }
      });
      for (let i = 0, len = list.length; i < len; i++) {
        list[i].delIds = i
      }
      that.feedbackInfo.feedbackDebits = list
    },
    sendData(status) {
      this.$refs['restaurantNumForm'].validate((valid) => {
        if (valid) {
          let list = this.feedbackInfo.feedbackDebits;
          let data = {
            storeDebitQty: this.feedbackInfo.feedback.storeDebitQty,
            debitList: list,
            status: status
          }
          reportApi.storeDebitIssue(this.feedbackId, data).then((res) => {
            if (res.code == 200) {
              this.$message.success('下发成功');
              this.getData()
            }
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    copyCreate() {
      let that = this;
      console.log(that.currentTab)
      if (this.feedbackInfo.feedbackReports[this.currentTab]) {
        let ttFeedbackReportId = this.feedbackInfo.feedbackReports[this.currentTab].ttFeedbackReportId
        return reportApi.copyCreateFeedbackReport(ttFeedbackReportId).then(resp => {
          that.feedbackInfo.feedbackReports.push(resp.data);
        });
      }


    },
    historyBack() {
      this.$router.go(-1);
    },

  },
  watch: {
    '$route.query'(to, from) {
      this.getData();
    }
  }
}

</script>
<style scoped>
.reportDetail .nodeList {
  margin-bottom: 20px;
}
</style>
<style>
.mouthClass .el-date-picker__header--bordered {
  display: none;
}

.reportDetail .el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 100%;
}
</style>

